import { Input, Select } from 'antd';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';

import { DebouncedInputNumber } from 'components/inputs';
import { UTCDatePicker } from 'components/UTCDatePicker';

export function ValueInput({ data, warn = false, onChange }) {
  const { t } = useTranslation();
  const theme = useTheme();
  const {
    label,
    type = '',
    options,
    value,
    defaultValue,
    min,
    max,
    delta = 1,
    required = true,
    disabled = false,
    allowClear = true,
    showSearch = true,
    width = '9em',
    popupMatchSelectWidth = true,
  } = data;
  const sharedStyle = {
    marginRight: '1em',
    border:
      warn || (required && (value === undefined || value === null))
        ? `2px solid ${theme.red}`
        : undefined,
    width,
  };

  if (type.match('string') && options) {
    const multipleType = type === '[string]';
    const mode = multipleType ? 'tags' : undefined;
    const placeholder = multipleType
      ? t('components.selectOptions', 'Select options')
      : t('components.selectAValue', 'Select a value');

    return (
      <Select
        mode={mode}
        aria-label={label}
        style={sharedStyle}
        placeholder={placeholder}
        defaultValue={defaultValue}
        {...(value !== undefined ? { value } : {})}
        onChange={onChange}
        allowClear={allowClear}
        showSearch={showSearch}
        disabled={disabled}
        popupMatchSelectWidth={popupMatchSelectWidth}
        options={options.map(({ id, label }) => ({
          value: id,
          label: label || (
            <span style={{ color: theme.noneTextColor }}>{t('components.none', 'None')}</span>
          ),
        }))}
      />
    );
  }

  if (type === 'number') {
    return (
      <DebouncedInputNumber
        aria-label={label}
        min={min}
        max={max}
        step={Number(delta)}
        value={value !== undefined ? value : defaultValue}
        onChange={value => {
          onChange(value);
        }}
        style={{
          ...sharedStyle,
          width: undefined,
        }}
        disabled={disabled}
      />
    );
  }

  if (type === 'string') {
    return (
      <Input
        placeholder={t('settings.value', 'Value')}
        {...(value !== undefined ? { value } : {})}
        defaultValue={defaultValue}
        style={sharedStyle}
        onChange={({ target: { value } }) => onChange(value)}
        allowClear={allowClear}
        disabled={disabled}
      />
    );
  }

  if (type === 'date') {
    return (
      <UTCDatePicker
        value={value ? moment(value) : undefined}
        defaultValue={defaultValue}
        onChange={(date, dateString) => onChange(dateString)}
        style={sharedStyle}
        allowClear={allowClear}
        disabled={disabled}
      />
    );
  }

  return <span>{t('components.unknownValueType', 'Err: Unknown Value Type')}</span>;
}
